import { useToast } from "@/hooks/use-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { undoNoShow } from "../services/undo-no-show";

export function useUndoNoShow() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({ source_id }: { source_id: string }) => undoNoShow(source_id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["session"], exact: false });
      queryClient.invalidateQueries({ queryKey: ["sessions"], exact: false });
      queryClient.invalidateQueries({ queryKey: ["user"], exact: false });
      toast({
        title: "Success",
        description: "Undo Marked No Show",
      });
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message || "Failed to Undo Mark No Show",
        variant: "destructive",
      });
    },
  });
}
